export default __webpack_public_path__ + "static/media/wallet-active.f4095ec9.svg";